import Stack from '@mui/material/Stack'
import { useAtomValue } from 'jotai'
import { countriesAtom as countriesState, countryState } from '@repo/unicity'
import { useEffect, useState } from 'react'

const CountrySelection = () => {
    const country = useAtomValue(countryState)
    const countries = useAtomValue(countriesState)
    const [tabs, setTabs] = useState<string[]>([])

    useEffect(() => {
        if (tabs.length === 0 && countries) {
            const items: string[] = []
            countries.data.feelgreat.forEach(item => {
                if (!items.includes(item.region)) {
                    items.push(item.region)
                }
            })
            setTabs(items)
        }
    }, [tabs.length])

    return (
        <Stack direction={'row'} alignItems={'center'} gap={1} pr={'28px'}>
            <Stack alignItems={'center'} mr="5px">
                <img src={country.flagUrl} alt="Flag" style={{ height: '15px', boxShadow: '0px 1px 2px 0px rgba(55, 52, 52, 0.44)' }} />
            </Stack>
            {/* <Stack direction={'row'} gap={'12px'} width={'fit-content'} alignItems={'center'}>
                {country.config.languageSettings.items.map((item, index) => {
                    return (
                        <Box
                            key={item.code}
                            sx={{ whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                            onClick={() => setLanguage(item.code)}>
                            <Typography variant="muted" fontSize={'12px'} fontWeight={language === item.code ? 700 : 400} color="#153862">
                                {item.name}
                            </Typography>
                            {index !== country.config.languageSettings.items.length - 1 && (
                                <Typography variant="muted" sx={{ paddingLeft: '10px' }} color="#153862">
                                    |
                                </Typography>
                            )}
                        </Box>
                    )
                })}
            </Stack> */}
            {/* <Dialog
                open={open}
                onClose={() => setOpen(false)}
                fullWidth
                sx={{
                    '& .MuiDialog-paper': {
                        borderRadius: '8px',
                        margin: '0px',
                        width: {
                            xs: '343px',
                            sm: '640px',
                            md: '1230px'
                        },
                        maxWidth: '100%'
                    }
                }}>
                <Box position={'absolute'} top={'15px'} right={'15px'} height={'20px'} sx={{ cursor: 'pointer' }} onClick={() => setOpen(false)}>
                    <CloseIcon width={'15px'} height={'15px'} />
                </Box>
                <DialogContent sx={{ padding: '0px' }}>
                    <Stack padding={'30px'}>
                        <Typography variant="h6">{translate('COUNTRY_SELECTION')}</Typography>
                    </Stack>
                    <Stack sx={{ paddingLeft: '30px' }}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <Tabs value={selectedTab} onChange={(_, value) => setSelectedTab(value)} aria-label="basic tabs example">
                                {tabs.map(tab => {
                                    return <Tab label={tab} />
                                })}
                            </Tabs>
                        </Box>
                    </Stack>
                    <Stack sx={{ padding: '30px', backgroundColor: '#DAF0F0' }}>
                        <Stack
                            sx={{
                                display: 'grid',
                                gridTemplateColumns: 'repeat(3, 1fr)',
                                maxHeight: '490px',
                                gap: '10px'
                            }}>
                            {countries.data.feelgreat.map(item => {
                                const selectedTabName = tabs[selectedTab as keyof typeof tabs]
                                if (item.region === selectedTabName) {
                                    return (
                                        <Stack gap={'20px'} direction={'row'} alignItems={'center'} key={item.short}>
                                            <Box sx={{ width: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <img src={item.flagUrl} alt={item.roman_name} />
                                            </Box>
                                            <Stack>
                                                <Typography variant="h6">{item.roman_name}</Typography>
                                                <Stack direction={'row'} gap={'10px'}>
                                                    {item.config.languageSettings.items.map((lang, index) => {
                                                        return (
                                                            <Box key={lang.code}>
                                                                <Typography variant="muted">{lang.name}</Typography>{' '}
                                                                {index !== item.config.languageSettings.items.length - 1 && (
                                                                    <Typography variant="muted">|</Typography>
                                                                )}
                                                            </Box>
                                                        )
                                                    })}
                                                </Stack>
                                            </Stack>
                                        </Stack>
                                    )
                                }
                            })}
                        </Stack>
                    </Stack>
                </DialogContent>
            </Dialog> */}
        </Stack>
    )
}

export default CountrySelection
